module.exports = __webpack_public_path__ + "img/5.3fdb55e0.jpg";